import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import WhatsAppIcon from './WhatsAppIcon';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Menu, 
  X,
  ChevronDown,
  Building,
  Scale,
  FileText,
  Users,
  Heart,
  Gavel,
  Globe,
  Shield,
  Briefcase,
  Home,
  User,
  HelpCircle,
  Star,
  BookOpen,
  Package,
  MessageSquare,
  Calendar,
  GraduationCap,
  Award
} from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // مراقبة التمرير لتغيير مظهر الهيدر
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // الخدمات القانونية
  const services = [
    { name: "الاستشارات القانونية", route: "/LegalConsultation", icon: MessageSquare },
    { name: "التمثيل القضائي والتقاضي", route: "/JudicialRepresentation", icon: Gavel },
    { name: "صياغة العقود والمستندات القانونية", route: "/ContractDrafting", icon: FileText },
    { name: "تقسيم الثروات", route: "/WealthDistribution", icon: Scale },
    { name: "التمثيل القانوني أمام محاكم الأحوال الشخصية", route: "/FamilyLaw", icon: Heart },
    { name: "التمثيل القانوني أمام المحاكم العامة", route: "/GeneralCourts", icon: Gavel },
    { name: "الشركات", route: "/Corporates", icon: Building },
    { name: "العمل والعمال", route: "/WorkAndLabor", icon: Users },
    { name: "حماية حقوق الملكية الفكرية", route: "/IntellectualProperty", icon: Shield },
    { name: "الحلول البديلة لفض المنازعات", route: "/AlternativeDisputeResolution", icon: Users },
    { name: "تحصيل الديون", route: "/debt-collection", icon: Shield },
    { name: "خدمات التوثيق", route: "/notarization-services", icon: FileText },
    { name: "خدمات الاستثمار الأجنبي", route: "/ForeignInvestment", icon: Globe },
    { name: "منازعات التأمين", route: "/insurance-disputes", icon: Shield },
    { name: "لوائح تنظيم العمل", route: "/work-regulations", icon: FileText },
    { name: "التجارة الإلكترونية", route: "/Ecommerce", icon: Globe }
  ];

  // المدونات
  const blogs = [
    { name: "المدونة الأولى", route: "/Blog1" },
    { name: "المدونة الثانية", route: "/Blog2" },
    { name: "المدونة الثالثة", route: "/Blog3" },
    { name: "المدونة الرابعة", route: "/Blog4" },
    { name: "المدونة الخامسة", route: "/Blog5" },
    { name: "المدونة السادسة", route: "/Blog6" }
  ];

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg' 
        : 'bg-white/90 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          
          {/* اللوجو للموبايل - اليمين */}
          <Link to="/" className="lg:hidden flex items-center whitespace-nowrap" onClick={closeMenu}>
            <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0">
              <img 
                src="/images/Logo/تصميم بدون عنوان - 2025-07-24T002454.362.png" 
                alt="مكتب أنس للمحاماة" 
                className="w-full h-full object-cover"
              />
            </div>
          </Link>
          
          {/* القائمة الرئيسية - الوسط */}
          <nav className="hidden lg:flex items-center space-x-8 space-x-reverse">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <Home className="w-4 h-4" />
              الرئيسية
            </Link>

            <Link 
              to="/About" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <User className="w-4 h-4" />
              من نحن
            </Link>

            <Link 
              to="/official-accreditations" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <Award className="w-4 h-4" />
              الاعتمادات الرسمية
            </Link>

            {/* خدماتنا - Dropdown */}
            <div className="relative">
              <div className="flex items-center">
                <Link
                  to="/Services"
                  className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
                  onClick={closeMenu}
                >
                  <Briefcase className="w-4 h-4" />
                  خدماتنا
                </Link>
                <button
                  onClick={() => toggleDropdown('services')}
                  className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 p-1"
                >
                  <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                    activeDropdown === 'services' ? 'rotate-180' : ''
                  }`} />
                </button>
              </div>
              
              {activeDropdown === 'services' && (
                <div className="absolute top-full right-0 mt-2 w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 p-4">
                  <div className="grid grid-cols-1 gap-2 max-h-96 overflow-y-auto">
                    {services.map((service, index) => (
                      <Link
                        key={index}
                        to={service.route}
                        className="flex items-center gap-3 p-3 rounded-xl hover:bg-[#0a3a23]/10 transition-all duration-200 group"
                        onClick={closeMenu}
                      >
                        <div className="w-8 h-8 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                          <service.icon className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-gray-700 group-hover:text-[#0a3a23] font-medium">
                          {service.name}
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link 
              to="/ConsultationBooking" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <Calendar className="w-3.5 h-3.5" />
              حجز الاستشارات
            </Link>

            <Link to="/" className="flex items-center whitespace-nowrap mx-8" onClick={closeMenu}>
              <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
                <img 
                  src="/images/Logo/تصميم بدون عنوان - 2025-07-24T002454.362.png" 
                  alt="مكتب أنس للمحاماة" 
                  className="w-full h-full object-cover"
                />
              </div>
            </Link>

            <Link 
              to="/FAQ" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <HelpCircle className="w-4 h-4" />
              الأسئلة الشائعة
            </Link>

            <Link 
              to="/Testimonials" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <Star className="w-4 h-4" />
              تجارب العملاء
            </Link>

            {/* المدونة - Dropdown */}
            <div className="relative">
              <div className="flex items-center">
                <Link
                  to="/Blog"
                  className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
                  onClick={closeMenu}
                >
                  <BookOpen className="w-4 h-4" />
                  المدونة
                </Link>
                <button
                  onClick={() => toggleDropdown('blog')}
                  className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 p-1"
                >
                  <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                    activeDropdown === 'blog' ? 'rotate-180' : ''
                  }`} />
                </button>
              </div>
              
              {activeDropdown === 'blog' && (
                <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-2xl shadow-2xl border border-gray-100 p-4">
                  <div className="space-y-2">
                    {blogs.map((blog, index) => (
                      <Link
                        key={index}
                        to={blog.route}
                        className="block p-3 rounded-xl hover:bg-[#0a3a23]/10 transition-all duration-200 text-gray-700 hover:text-[#0a3a23] font-medium"
                        onClick={closeMenu}
                      >
                        {blog.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link 
              to="/Packages" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <Package className="w-4 h-4" />
              الباقات
            </Link>

            {/* التوظيف - Dropdown */}
            <div className="relative">
              <div className="flex items-center">
            <Link 
              to="/Careers" 
              className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 flex items-center gap-2 whitespace-nowrap text-sm"
              onClick={closeMenu}
            >
              <Users className="w-4 h-4" />
              التوظيف
            </Link>
                <button
                  onClick={() => toggleDropdown('careers')}
                  className="text-gray-700 hover:text-[#0a3a23] font-medium transition-colors duration-200 p-1"
                >
                  <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                    activeDropdown === 'careers' ? 'rotate-180' : ''
                  }`} />
                </button>
              </div>
              
              {activeDropdown === 'careers' && (
                <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-2xl shadow-2xl border border-gray-100 p-4">
                  <div className="space-y-2">
                    <Link
                      to="/cooperative-training"
                      className="block p-3 rounded-xl hover:bg-[#0a3a23]/10 transition-all duration-200 text-gray-700 hover:text-[#0a3a23] font-medium flex items-center gap-3"
                      onClick={closeMenu}
                    >
                      <GraduationCap className="w-4 h-4" />
                      التدريب التعاوني
                    </Link>
                  </div>
                </div>
              )}
            </div>

          </nav>



          {/* زر القائمة للموبايل - اليسار */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#0a3a23] transition-colors duration-200"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* القائمة المنسدلة للموبايل */}
        {isMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 max-h-[70vh] overflow-y-auto">
            <div className="p-4 space-y-3">
              <Link 
                to="/" 
                className="block px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200 flex items-center gap-3 text-base font-medium"
                onClick={closeMenu}
              >
                <Home className="w-5 h-5" />
                الرئيسية
              </Link>

              <Link 
                to="/About" 
                className="block px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200 flex items-center gap-3 text-base font-medium"
                onClick={closeMenu}
              >
                <User className="w-5 h-5" />
                من نحن
              </Link>

              <Link 
                to="/official-accreditations" 
                className="block px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200 flex items-center gap-3 text-base font-medium"
                onClick={closeMenu}
              >
                <Award className="w-5 h-5" />
                الاعتمادات الرسمية
              </Link>

              {/* خدماتنا للموبايل */}
              <div>
                <div className="flex items-center justify-between px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200">
                  <Link 
                    to="/Services" 
                    className="flex items-center gap-3 flex-1"
                    onClick={closeMenu}
                  >
                    <Briefcase className="w-5 h-5" />
                    <span className="text-base font-medium">خدماتنا</span>
                  </Link>
                  <button
                    onClick={() => toggleDropdown('services-mobile')}
                    className="p-1"
                  >
                    <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                      activeDropdown === 'services-mobile' ? 'rotate-180' : ''
                    }`} />
                  </button>
                </div>
                
                {activeDropdown === 'services-mobile' && (
                  <div className="mt-2 mr-8 bg-gray-50 rounded-xl p-3 space-y-1">
                    {services.map((service, index) => (
                      <Link
                        key={index}
                        to={service.route}
                        className="block px-3 py-2 text-gray-600 hover:text-[#0a3a23] hover:bg-white rounded-lg transition-all duration-200 flex items-center gap-2 text-sm"
                        onClick={closeMenu}
                      >
                        <service.icon className="w-4 h-4" />
                        {service.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link 
                to="/ConsultationBooking" 
                className="block px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200 flex items-center gap-3 text-base font-medium"
                onClick={closeMenu}
              >
                <Calendar className="w-5 h-5" />
                حجز الاستشارات
              </Link>

              <Link 
                to="/FAQ" 
                className="block px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200 flex items-center gap-3 text-base font-medium"
                onClick={closeMenu}
              >
                <HelpCircle className="w-5 h-5" />
                الأسئلة الشائعة
              </Link>

              <Link 
                to="/Testimonials" 
                className="block px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200 flex items-center gap-3 text-base font-medium"
                onClick={closeMenu}
              >
                <Star className="w-5 h-5" />
                آراء العملاء
              </Link>

              {/* المدونة للموبايل */}
              <div>
                <div className="flex items-center justify-between px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200">
                  <Link 
                    to="/Blog" 
                    className="flex items-center gap-3 flex-1"
                    onClick={closeMenu}
                  >
                    <BookOpen className="w-5 h-5" />
                    <span className="text-base font-medium">المدونة</span>
                  </Link>
                  <button
                    onClick={() => toggleDropdown('blog-mobile')}
                    className="p-1"
                  >
                    <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                      activeDropdown === 'blog-mobile' ? 'rotate-180' : ''
                    }`} />
                  </button>
                </div>
                
                {activeDropdown === 'blog-mobile' && (
                  <div className="mt-2 mr-8 bg-gray-50 rounded-xl p-3 space-y-1">
                    {blogs.map((blog, index) => (
                      <Link
                        key={index}
                        to={blog.route}
                        className="block px-3 py-2 text-gray-600 hover:text-[#0a3a23] hover:bg-white rounded-lg transition-all duration-200 text-sm"
                        onClick={closeMenu}
                      >
                        {blog.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link 
                to="/Packages" 
                className="block px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200 flex items-center gap-3 text-base font-medium"
                onClick={closeMenu}
              >
                <Package className="w-5 h-5" />
                الباقات
              </Link>

              {/* التوظيف للموبايل */}
              <div>
                <div className="flex items-center justify-between px-4 py-4 text-gray-700 hover:text-[#0a3a23] hover:bg-green-50 rounded-xl transition-all duration-200">
                  <Link 
                    to="/Careers" 
                    className="flex items-center gap-3 flex-1"
                    onClick={closeMenu}
                  >
                    <Users className="w-5 h-5" />
                    <span className="text-base font-medium">التوظيف</span>
                  </Link>
                  <button
                    onClick={() => toggleDropdown('careers-mobile')}
                    className="p-1"
                  >
                    <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                      activeDropdown === 'careers-mobile' ? 'rotate-180' : ''
                    }`} />
                  </button>
                </div>
                
                {activeDropdown === 'careers-mobile' && (
                  <div className="mt-2 mr-8 bg-gray-50 rounded-xl p-3 space-y-1">
              <Link 
                      to="/cooperative-training"
                      className="block px-3 py-2 text-gray-600 hover:text-[#0a3a23] hover:bg-white rounded-lg transition-all duration-200 text-sm"
                onClick={closeMenu}
              >
                      <GraduationCap className="w-4 h-4" />
                      التدريب التعاوني
              </Link>
                  </div>
                )}
              </div>



              
              {/* مساحة إضافية في النهاية */}
              <div className="h-4"></div>
            </div>
          </div>
        )}
      </div>


    </header>
  );
};

export default Header; 
